import Mock from 'mockjs'
import axios from 'axios'
import qs from 'qs'
import {setToken,setName,removeToken,removeName,getToken,getWxappid,removeWxappid,set_template_admin,get_template_admin,del_template_admin} from "@/utils/auth"
var siteurl = 'http://diy.eingdong.com/service/index.php';
if(location.hostname ==='localhost'){
  siteurl = 'http://localhost/service/index.php'
}
export function loginUrl(){
	return siteurl+"/login"
}
export function getSite(){
  return siteurl
}
export function get_qrcode(){
	return siteurl + "/qrcode/get_qrcode?token="+getToken()+"&app_id="+getWxappid()+"&";
}
export function getUpload(){
  return siteurl+"/upload/img?token="+getToken()
}
export function getUpload_video(){
	return siteurl+"/upload/video?token="+getToken()
}
export function getImglist(data,_this,fn){
  ajax({
    url:'/upload/get_list',
    _this:_this,
    data:data,
    ajaxfn:function(res){
      fn(res)
    }
  });
}

export function delMyImg(data,_this,fn){
  ajax({
    url:'/upload/del_img',
    _this:_this,
    data:data,
    ajaxfn:function(res){
      fn(res)
    }
  });
}
export function get_video_list(data,_this,fn){
	ajax({
		url:'/upload/get_video_list',
		_this:_this,
		data:data,
		ajaxfn:function(res){
			fn(res)
		}
	});
}
export function change_goods_order_by(data, _this, fn) {
  ajax({
    url: '/goods/change_goods_order_by',
    _this, data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function del_video(data,_this,fn){
	ajax({
		url:'/upload/del_video',
		_this:_this,
		data:data,
		ajaxfn:function(res){
			fn(res)
		}
	});
}
function ajax3({url,data={},_this,ajaxfn}){
	if(getWxappid()){
		data.app_id = getWxappid();
	}
	axios({
		method: 'POST',
		url: siteurl+ url +"?token="+ getToken(),
		data:qs.stringify(data)
	})
	.then(function (res) {
		if(res.data.status==195){
			window.vuevm.$message.error(res.data.msg)
			removeToken();
			removeName();
			setTimeout(()=>{
				location.reload();
			},1500)
			return false;
		}
		if(res.data.status ==-1){
			window.vuevm.$message({
				type: 'info',
				message: res.data.msg
			})
			// return false;
		}
		if(res.data.status ==-2){
			window.vuevm.$message({
				type: 'warning',
				message: res.data.msg
			})
			return false;
		}
		ajaxfn(res);
	})
	.catch(function (res) {
		window.vuevm.$message({
			type: 'error',
			message: "网络连接请求失败,请稍后重试"
		})
	});
}

export function test({url,data={},_this,ajaxfn}){
  axios({
  	method: 'GET',
  	url: url,
  	data:qs.stringify(data)
  })
  .then(function (res) {
  	ajaxfn(res);
  })
  .catch(function (res) {
  	window.vuevm.$message({
  		type: 'error',
  		message: "网络连接请求失败,请稍后重试"
  	})
  });
}

export default function ajax({url,data={},_this,ajaxfn}){
	if(getWxappid()){
		data.app_id = getWxappid();
	}
	axios({
		method: 'POST',
		url: siteurl+ url +"?token="+ getToken(),
		data:qs.stringify(data)
	})
	.then(function (res) {
		if(res.data.status==195){
			window.vuevm.$message.error(res.data.msg)
			removeToken();
			removeName();
			setTimeout(()=>{
				location.reload();
			},1500)
			return false;
		}
		if(res.data.status ==-1){
			window.vuevm.$message({
				type: 'info',
				message: res.data.msg
			})
			return false;
		}
		if(res.data.status ==-2){
			window.vuevm.$message({
				type: 'warning',
				message: res.data.msg
			})
			return false;
		}
		ajaxfn(res);
	})
	.catch(function (res) {
		window.vuevm.$message({
			type: 'error',
			message: "网络连接请求失败,请稍后重试"
		})
	});
}




// 登录
export function login(info,_this){
	ajax({
		url:'/login',
		_this,
		data:info,
		ajaxfn:function(res){
			// res.data.token = res.data.token=="undefined"? "":res.data.token;
			setToken(res.data.token);
			setName(res.data.username);
			set_template_admin(res.data.template_admin);
			_this.$router.push({path:'/'})
			_this.$message({
				type:'success',
				message:res.data.msg
			})
			location.reload()
		}
	});
}
// 登出
export function logout(_this,fn){
	ajax({
		url:'/login/logout',
		_this:_this,
		ajaxfn:function(res){
			removeToken();
			removeName();
			removeWxappid();
			del_template_admin(res.data.template_admin);
			_this.$message({
				type:'success',
				message:res.data.msg
			})
			setTimeout(()=>{
				location.reload()
			},1600)
			fn(res)
		}
	});
}

export function change_password(data,_this,fn){
	ajax({
		url:'/login/change_password',
		data,_this,
		ajaxfn:function(res){
			fn(res)
		}
	});
}

// 获取授权
export function getUserAuth(_this,fn){
	ajax({
		url:'/authorization/get_authorization_info',
		_this:_this,
		ajaxfn:function(res){
			fn(res)
		}
	});
}
// 体验名单
export function getUserExpList(_this,fn){
	ajax({
		url:'/authorization/memberauth',
		_this:_this,
		ajaxfn:function(res){
			fn(res)
		}
	});
}

export function addUserExp(data,_this,fn){
	ajax({
		url:'/authorization/add_memberauth',
		_this:_this,
		data:data,
		ajaxfn:function(res){
			fn(res)
		}
	});
}

export function delUserExp(data,_this,fn){
	ajax({
		url:'/authorization/unbind_tester',
		_this:_this,
		data:data,
		ajaxfn:function(res){
			fn(res)
		}
	});
}


export function submitCommit(_this,fn){
	ajax({
		url:'/miniapp/commit',
		_this:_this,
		ajaxfn:function(res){
			fn(res)
		}
	});
}

export function getQrCode(_this,fn){
	ajax({
		url:'/miniapp/get_qrcode',
		_this:_this,
		ajaxfn:function(res){
			fn(res)
		}
	});
}






// 首页接口
export function addApp(data,_this,fn){
	ajax({
		url:'/template/create',
		_this:_this,
		data:data,
		ajaxfn:function(res){
			fn(res)
		}
	});
}
export function getApplist(_this,fn){
	ajax({
		url:'/miniapp/get_list',
		_this:_this,
		ajaxfn:function(res){
			fn(res)
		}
	});
}
export function delApp(data,_this,fn){
	ajax({
		url:'/template/del',
		_this:_this,
		data:data,
		ajaxfn:function(res){
			fn(res)
		}
	});
}
export function saveConfig(data,_this,fn){
	ajax({
		url:'/design/save',
		_this:_this,
		data:data,
		ajaxfn:function(res){
			fn(res)
		}
	});
}
// 首页接口end


export function getTemplate(data,_this,fn){
	ajax({
		url:'/template/get_template',
		_this,data,
		ajaxfn:function(res){
			fn(res)
		}
	});
}

export function CreatApp(data,_this,fn){
	ajax({
		url:'/template/create_app',
		_this,data,
		ajaxfn:function(res){
			fn(res)
		}
	});
}


 //获取文章分类

 export function add_classify(data,_this,fn){
 	ajax({
 		url:'/article/add_classify',
 		_this:_this,
 		data:data,
 		ajaxfn:function(res){
 			fn(res)
 		}
 	});
 }


 export function delArticlerClassify(data,_this,fn){
 	ajax({
 		url:'/article/del_classify',
 		_this:_this,
 		data:data,
 		ajaxfn:function(res){
 			fn(res)
 		}
 	});
 }
 export function get_classify_list(_this,fn){
 	ajax({
 		url:'/article/get_classify_list',
 		_this:_this,
 		ajaxfn:function(res){
 			fn(res)
 		}
 	});
 }

 export function get_classify_article_list(data,_this,fn){
 	ajax({
 		url:'/article/get_classify_article_list',
 		_this:_this,
 		data:data,
 		ajaxfn:function(res){
 			fn(res)
 		}
 	});
 }

 export function editor_classify(data,_this,fn){
 	ajax({
 		url:'/article/editor_classify',
 		_this:_this,
 		data:data,
 		ajaxfn:function(res){
 			fn(res)
 		}
 	});
 }

// 文章

export function addArticle(data,_this,fn){
  ajax({
   url:'/article/add',
   _this:_this,
   data:data,
   ajaxfn:function(res){
    fn(res)
  }
});
}
export function delArticle(data,_this,fn){
  ajax({
   url:'/article/del',
   _this:_this,
   data:data,
   ajaxfn:function(res){
    fn(res)
  }
});
}
export function editArticle(data,_this,fn){
  ajax({
   url:'/article/editor',
   _this:_this,
   data:data,
   ajaxfn:function(res){
    fn(res)
  }
});
}

export function getArticleList(data,_this,fn){
  ajax({
   url:'/article/get_list',
   _this:_this,
   data:data,
   ajaxfn:function(res){
    fn(res)
  }
});
}
export function getArticleContent(data,_this,fn){
  ajax({
   url:'/article/get_content',
   _this:_this,
   data:data,
   ajaxfn:function(res){
    fn(res)
  }
});
}

export function getArticleOnce(data,_this,fn){
  ajax({
   url:'/article/get_info',
   _this:_this,
   data:data,
   ajaxfn:function(res){
    fn(res)
  }
});
}

 //获取服务分类

 export function add_sever_classify(data,_this,fn){
 	ajax({
 		url:'/service/add_classify',
 		_this:_this,
 		data:data,
 		ajaxfn:function(res){
 			fn(res)
 		}
 	});
 }
 export function delSeverClassify(data,_this,fn){
 	ajax({
 		url:'/service/del_classify',
 		_this:_this,
 		data:data,
 		ajaxfn:function(res){
 			fn(res)
 		}
 	});
 }


 export function get_sever_classify_list(_this,fn){
 	ajax({
 		url:'/service/get_classify_list',
 		_this:_this,
 		ajaxfn:function(res){
 			fn(res)
 		}
 	});
 }

 export function editor_sever_classify(data,_this,fn){
 	ajax({
 		url:'/service/editor_classify',
 		_this:_this,
 		data:data,
 		ajaxfn:function(res){
 			fn(res)
 		}
 	});
 }
// 服务
export function addSever(data,_this,fn){
  ajax({
   url:'/service/add',
   _this:_this,
   data:data,
   ajaxfn:function(res){
    fn(res)
  }
});
}
export function editSever(data,_this,fn){
  ajax({
   url:'/service/editor',
   _this:_this,
   data:data,
   ajaxfn:function(res){
    fn(res)
  }
});
}

export function getSeverList(data,_this,fn){
  ajax({
   url:'/service/get_list',
   _this:_this,
   data:data,
   ajaxfn:function(res){
    res = sale_price_to_null(res)
    fn(res)
  }
});
}
export function delSever(data,_this,fn){
  ajax({
   url:'/service/del',
   _this:_this,
   data:data,
   ajaxfn:function(res){
    fn(res)
  }
});
}

export function getSeverContent(data,_this,fn){
  ajax({
   url:'/service/get_content',
   _this:_this,
   data:data,
   ajaxfn:function(res){
    fn(res)
  }
});
}
 // 名片

 export function addCard(data,_this,fn){
 	ajax({
 		url:'/card/add',
 		_this:_this,
 		data:data,
 		ajaxfn:function(res){
 			fn(res)
 		}
 	});
 }
 export function editCard(data,_this,fn){
 	ajax({
 		url:'/card/editor',
 		_this:_this,
 		data:data,
 		ajaxfn:function(res){
 			fn(res)
 		}
 	});
 }

 export function delCard(data,_this,fn){
 	ajax({
 		url:'/card/del',
 		_this:_this,
 		data:data,
 		ajaxfn:function(res){
 			fn(res)
 		}
 	});
 }

 export function getCardList(_this,fn){
 	ajax({
 		url:'/card/get_list',
 		_this:_this,
 		ajaxfn:function(res){
 			fn(res)
 		}
 	});
 }


// 设计i小程序

export function getappConfig(_this,fn){
  ajax({
   url:'/design/get',
   _this:_this,
   ajaxfn:function(res){
    fn(res)
  }
});
}
// 添加表单
export function addForms(data,_this,fn){
  ajax({
   url:'/form/add',
   _this:_this,
   data:data,
   ajaxfn:function(res){
    fn(res)
  }
});
}
export function editForms(data,_this,fn){
  ajax({
   url:'/form/editor_configuration',
   _this:_this,
   data:data,
   ajaxfn:function(res){
    fn(res)
  }
});
}

export function reNameForm(data,_this,fn){
  ajax({
   url:'/form/editor_name',
   _this:_this,
   data:data,
   ajaxfn:function(res){
    fn(res)
  }
});
}
export function delForm(data,_this,fn){
  ajax({
   url:'/form/del',
   _this:_this,
   data:data,
   ajaxfn:function(res){
    fn(res)
  }
});
}

export function delUserForm(data,_this,fn){
  ajax({
   url:'/form/del_record',
   _this:_this,
   data:data,
   ajaxfn:function(res){
    fn(res)
  }
});
}

export function getForms(_this,fn){
  ajax({
   url:'/form/get_list',
   _this:_this,
   ajaxfn:function(res){
    fn(res)
  }
});
}

export function getUserForm(data,_this,fn){
  ajax({
   url:'/form/get_record_list',
   _this:_this,
   data:data,
   ajaxfn:function(res){
    fn(res)
  }
});
}
 // 订单
 export function getOrderList(data,_this,fn){
 	ajax({
 		url:'/service/get_order_list',
 		_this:_this,
 		data:data,
 		ajaxfn:function(res){
 			fn(res)
 		}
 	});
 }
 export function orderCancle(data,_this,fn){
 	ajax({
 		url:'/service/cancel_order',
 		_this:_this,
 		data:data,
 		ajaxfn:function(res){
 			fn(res)
 		}
 	});
 }

 export function orderToSuccess(data,_this,fn){
 	console.log(1231234)
 	ajax({
 		url:'/service/complete_order',
 		_this:_this,
 		data:data,
 		ajaxfn:function(res){
 			fn(res)
 		}
 	});
 }

 //获取商品分类

 export function addGoodsClassify(data,_this,fn){
 	ajax({
 		url:'/goods/add_classify',
 		_this:_this,
 		data:data,
 		ajaxfn:function(res){
 			fn(res)
 		}
 	});
 }


 export function delGoodsClassify(data,_this,fn){
 	ajax({
 		url:'/goods/del_classify',
 		_this:_this,
 		data:data,
 		ajaxfn:function(res){
 			fn(res)
 		}
 	});
 }
 export function getClassifyList(_this,fn){
 	ajax({
 		url:'/goods/get_classify_list',
 		_this:_this,
 		ajaxfn:function(res){
 			fn(res)
 		}
 	});
 }

 export function editGoodsClassify(data,_this,fn){
 	ajax({
 		url:'/goods/editor_classify',
 		_this:_this,
 		data:data,
 		ajaxfn:function(res){
 			fn(res)
 		}
 	});
 }

 export function addGoods(data,_this,fn){
 	ajax({
 		url:'/goods/add',
 		_this:_this,
 		data:data,
 		ajaxfn:function(res){
 			fn(res)
 		}
 	});
 }
 export function editGoods(data,_this,fn){
 	ajax({
 		url:'/goods/editor',
 		_this:_this,
 		data:data,
 		ajaxfn:function(res){
 			fn(res)
 		}
 	});
 }

 export function getGoodsList(data,_this,fn){
 	ajax({
 		url:'/goods/get_list',
 		_this:_this,
 		data:data,
 		ajaxfn:function(res){
 			fn(res)
 		}
 	});
 }

 export function delGoods(data,_this,fn){
 	ajax({
 		url:'/goods/delete',
 		_this,data,
 		ajaxfn:function(res){
 			fn(res)
 		}
 	});
 }

 export function get_express_set(_this,fn){
 	ajax({
 		url:'/goods/get_express_set',
 		_this,
 		ajaxfn:function(res){
 			fn(res)
 		}
 	});
 }
 export function save_express_set(data,_this,fn){
 	ajax({
 		url:'/goods/save_express_set',
 		_this,data,
 		ajaxfn:function(res){
 			fn(res)
 		}
 	});
 }


 export function getAudit(_this,fn){
  ajax({
    url:'/miniapp/get_category',
    _this:_this,
    ajaxfn:function(res){
      fn(res)
    }
  });
}

export function subAudit(data,_this,fn){
  ajax({
    url:'/miniapp/submit_audit',
    data,_this,
    ajaxfn:function(res){
      fn(res)
    }
  });
}
export function backAudit(_this,fn){
  ajax({
    url:'/miniapp/undocodeaudit',
    _this,
    ajaxfn:function(res){
      fn(res)
    }
  });
}

export function getAuditStatus(_this,fn){
  ajax({
    url:'/miniapp/get_audit_log',
    _this,
    ajaxfn:function(res){
      fn(res)
    }
  });
}

export function get_goods_order(data,_this,fn){
  ajax({
    url:'/goods/get_goods_order',
    data,_this,
    ajaxfn:function(res){
      fn(res)
    }
  });
}

export function get_goods_order_detail(data,_this,fn){
  ajax({
    url:'/goods/get_goods_order_detail',
    data,_this,
    ajaxfn:function(res){
      fn(res)
    }
  });
}

export function saveExpress(data,_this,fn){
  ajax({
    url:'/goods/save_express',
    data,_this,
    ajaxfn:function(res){
      fn(res)
    }
  });
}

export function query_logistics(data,_this,fn){
  ajax({
    url:'/goods/query_logistics',
    data,_this,
    ajaxfn:function(res){
      fn(res)
    }
  });
}
export function changePutway(data,_this,fn){
  ajax({
    url:'/goods/change_putway',
    data,_this,
    ajaxfn:function(res){
      fn(res)
    }
  });
}

export function addTicket(data, _this, fn) {
  ajax({
    url: '/coupon/add',
    _this: _this,
    data: data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function editTicket(data, _this, fn) {
  ajax({
    url: '/coupon/editor',
    _this: _this,
    data: data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function getTicketList(data, _this, fn) {
  ajax({
    url: '/coupon/get_list',
    _this: _this,
    data: data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function delTicket(data, _this, fn) {
  ajax({
    url: '/coupon/del',
    _this: _this,
    data: data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}


export function rechargeSwitch(data, _this, fn) {
  ajax({
    url: '/recharge/setting_switch',
    _this,data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function rechargeGet(_this, fn) {
  ajax({
    url: '/recharge/get_setting',
    _this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function getTopupList(_this, fn) {
  ajax({
    url: '/recharge/get_option_list',
    _this: _this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function addtopup(data, _this, fn) {
  ajax({
    url: '/recharge/add_option',
    _this: _this,
    data: data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function deltopup(data, _this, fn) {
  ajax({
    url: '/recharge/delete_option',
    _this: _this,
    data: data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function getUserTopupList(data, _this, fn) {
  ajax({
    url: '/recharge/get_list',
    _this, data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}


export function distributionSwitch(data, _this, fn) {
  ajax({
    url: '/distributor/setting_switch',
    _this,data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function distributionSave(data, _this, fn) {
  ajax({
    url: '/distributor/setting',
    _this,data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function distributionGet(_this, fn) {
  ajax({
    url: '/distributor/get_setting',
    _this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function get_taobao_goods( data,_this, fn) {
  ajax({
    url: '/Gather/get_taobao_goods',
    data,_this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}


export function get_template_classify( _this, fn) {
  ajax({
    url: '/template/get_template_classify',
    _this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function submitTemplate( data,_this, fn) {
  ajax({
    url: '/template/submit_template',
    data,_this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function cancle_template( data,_this, fn) {
  ajax({
    url: '/template/cancle_template',
    data,_this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function get_store_setting( _this, fn) {
  ajax({
    url: '/setting/get_setting',
    _this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function save_store_setting( data,_this, fn) {
  ajax({
    url: '/setting/save_store_setting',
    data,_this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}


export function changeOrderby( data,_this, fn) {
  ajax({
    url: '/goods/changeOrderby',
    data,_this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}



export function get_integral_setting( _this, fn) {
  ajax({
    url: '/integral/get_integral_setting',
    _this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function save_integral_setting( data,_this, fn) {
  ajax({
    url: '/integral/save_integral_setting',
    data,_this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}


export function switch_groupBuy( data,_this, fn) {
  ajax({
    url: '/groupbuy/switch_groupBuy',
    data,_this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function get_groupBuy_list( data,_this, fn) {
  ajax({
    url: '/groupbuy/get_groupBuy_list',
    data,_this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function get_groupBuy( _this, fn) {
  ajax({
    url: '/groupbuy/get_groupBuy',
    _this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function get_goods_list( data,_this, fn) {
  ajax({
    url: '/goods/get_list',
    data,_this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function modifyheadimage(data, _this, fn) {
  ajax({
    url: '/mp/modifyheadimage',
    data, _this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function setnickname(data, _this, fn) {
  ajax3({
    url: '/mp/setnickname',
    data, _this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function checkwxverifynickname(data, _this, fn) {
  ajax({
    url: '/mp/checkwxverifynickname',
    data, _this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function getallcategories(data, _this, fn) {
  ajax({
    url: '/mp/getallcategories',
    data, _this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function modifysignature(data, _this, fn) {
  ajax({
    url: '/mp/modifysignature',
    data, _this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function del_categories(data, _this, fn) {
  ajax({
    url: '/mp/deletecategory',
    data, _this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function addcategory(data, _this, fn) {
  ajax({
    url: '/mp/addcategory',
    data, _this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function getcategory(_this, fn) {
  ajax({
    url: '/mp/getcategory',
    _this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function add_groupBuy( data,_this, fn) {
  ajax({
    url: '/groupbuy/add',
    data,_this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function edit_groupBuy( data,_this, fn) {
  ajax({
    url: '/groupbuy/edit',
    data,_this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function del_groupBuy( data,_this, fn) {
  ajax({
    url: '/groupbuy/del',
    data,_this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function changeputaway( data,_this, fn) {
  ajax({
    url: '/groupbuy/changeputaway',
    data,_this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function save_groupBuy( data,_this, fn) {
  ajax({
    url: '/groupbuy/save_groupBuy',
    data,_this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function get_groupBuy_order( data,_this, fn) {
  ajax({
    url: '/groupbuy/get_groupBuy_order',
    data,_this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}





export function codeTovideo(url,_this,fn){
  console.log(url)
  var vids = url.substr(0,url.lastIndexOf("."));
  vids = vids.substr(vids.lastIndexOf("/")+1)
  console.log(vids)
  ajax({
   url:'/qv/get_info',
   _this:_this,
   data:{vids:vids},
   ajaxfn:function(res){
    res.data = res.data.replace("QZOutputJson=" ,'');
    res.data = res.data.substr(0,res.data.lastIndexOf(";"))
    res = JSON.parse(res.data)
    console.log(res.msg)
    if(res.msg == "vid is wrong"){
     _this.$message({
      type:'warning',
      message:"视频解析错误，请检查视频链接或换个视频"
    })
     return false
   }
   var url = res.vl.vi[0].ul.ui[0].url + res.vl.vi[0].fn  + '?vkey=' + res.vl.vi[0].fvkey
   console.log(url)
   fn(url)
 }
});
}



 //获取视频分类

 export function addVideoClassify(data,_this,fn){
  ajax({
    url:'/Video/add_classify',
    _this:_this,
    data:data,
    ajaxfn:function(res){
      fn(res)
    }
  });
}


export function delVideoClassify(data,_this,fn){
  ajax({
    url:'/Video/del_classify',
    _this:_this,
    data:data,
    ajaxfn:function(res){
      fn(res)
    }
  });
}
export function getVideoClassifyList(_this,fn){
  ajax({
    url:'/Video/get_classify_list',
    _this:_this,
    ajaxfn:function(res){
      fn(res)
    }
  });
}

export function editVideoClassify(data,_this,fn){
  ajax({
    url:'/Video/editor_classify',
    _this:_this,
    data:data,
    ajaxfn:function(res){
      fn(res)
    }
  });
}

export function changeVideoOrderby( data,_this, fn) {
  ajax({
    url: '/video/changeOrderby',
    data,_this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}


export function add_video( data, fn) {
  ajax({
    url: '/video/add_video',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function edit_video( data, fn) {
  ajax({
    url: '/video/edit_video',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function del_class_video( data, fn) {
  ajax({
    url: '/video/del_class_video',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}


export function get_course_list( data,_this, fn) {
  ajax({
    url: '/video/get_course_list',
    data,_this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function get_course_list_all( data,_this, fn) {
  ajax({
    url: '/video/get_course_list',
    data,_this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function change_video_putway( data,_this, fn) {
  ajax({
    url: '/video/change_video_putway',
    data,_this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function add_group( data,_this, fn) {
  ajax({
    url: '/upload/add_group',
    data,_this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}


export function del_group( data,_this, fn) {
  ajax({
    url: '/upload/del_group',
    data,_this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function move_to_group( data,_this, fn) {
  ajax({
    url: '/upload/move_to_group',
    data,_this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function del_img_mult( data,_this, fn) {
  ajax({
    url: '/upload/del_img_mult',
    data,_this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function del_video_mult( data,_this, fn) {
  ajax({
    url: '/upload/del_video_mult',
    data,_this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function get_app_id(_this, fn) {
  ajax({
    url: '/qrcode/get_app_id',
    _this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function reset_name( data,_this, fn) {
  ajax({
    url: '/upload/reset_name',
    data,_this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function signSubmitvip( data,_this, fn) {
  ajax({
    url: '/login/signSubmitvip',
    data,_this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function getbindCode( _this, fn) {
  ajax({
    url: '/bindw/t',
    _this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function getbindCodeRe( data,_this, fn) {
  ajax({
    url: '/bindw/bind_x' ,
    data,_this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function getWechatInform(_this, fn) {
  ajax({
    url: '/order_notification/get_wechat_receiver',
    _this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function delWechatInform(data, _this, fn) {
  ajax({
    url: '/order_notification/del_wechat_receiver',
    _this, data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function get_user_list(data, _this, fn) {
  ajax({
    url: '/user/get_user_list',
    _this, data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function changeScore(data, _this, fn) {
  ajax({
    url: '/user/changeScore',
    _this, data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function changeBalance(data, _this, fn) {
  ajax({
    url: '/user/changeBalance',
    _this, data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function addWechatInform(data, _this, fn) {
  ajax({
    url: '/Bindw/bind_s',
    _this, data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function create_miniapp(data, _this, fn) {
  ajax({
    url: '/mp/create_miniapp',
     _this,data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function get_distributor_group(data, _this, fn) {
  ajax({
    url: '/user/get_distributor_group',
     _this,data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function getaccountbasicinfo(_this, fn) {
  ajax({
    url: '/mp/getaccountbasicinfo',
    _this,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function changeHide(data, _this, fn) {
  ajax({
    url: '/goods/changeHide',
    _this, data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}





// 获取授权
// export function getUserAuth(_this, fn) {
//   ajax({
//     url: '/authorization/get_authorization_info',
//     _this,data,
//     ajaxfn: function(res) {
//       fn(res)
//     }
//   })
// }

// 折扣价 0.00 => ""
function sale_price_to_null (res){
  if(res.data.list ){
    res.data.list.forEach((val)=>{
      val.sale_price = parseFloat(val.sale_price) == 0 ? "" : val.sale_price
    })
  }
  if(res.data.service){
    res.data.service.sale_price = parseFloat(res.data.service.sale_price) == 0 ? "" : res.data.service.sale_price
  }
  return res
}



// WEBPACK FOOTER //
// ./src/api/api.js